<ion-header class="remove-margin-from-safe-area ion-no-border">
<ion-toolbar >
<ion-grid>
  <ion-row>
    <ion-col>
      <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button (click)="closeModal()" 
          ><ion-icon color="dark" name="close"></ion-icon
        ></ion-button>
      </ion-buttons>
    </ion-toolbar>
    </ion-col>
  </ion-row>
  
</ion-grid>


</ion-toolbar> 
</ion-header>

<ion-content>
  <app-pagecontent  [path]="'guest/checkout'"></app-pagecontent>
  <app-loading-spinner  *ngIf="!loaded"></app-loading-spinner>
<ion-grid *ngIf="loaded" class="single-col-wider">
  <ion-row>
    <ion-col style="text-align: center;">
      <h2 class="subheader-regular">{{('keys.data.payments.cart' | translate : {Default:'Cart'}) || 'Cart'}}</h2>
    </ion-col>
  </ion-row>
<ion-row>
<ion-col>
  <ion-card class="card-shadow-7">
<ion-grid>
  
<ion-row>
<ion-col>
<ion-item   style="--padding-end: 0.5em;
  --padding-start: 0.5em;" class="paragraph-bold">
    
    <ion-label > {{('keys.data.violations.violations' | translate : {Default:'Violations'}) || 'Violations'}} </ion-label>
      
      <ion-label class="ion-text-right">
        <span
         
          
          >{{parseFloat(violation['CalculatedFine']['finalTotal']) 
          | currency}}</span
        >
        
      </ion-label>
      
  </ion-item>
</ion-col>
</ion-row>
<ion-row>
<ion-col>
<ion-grid  >       
<ion-row>
<ion-col class="ion-no-padding">
  <ion-item lines="none" >
    <ion-label >
      {{violation['Ticket']}}
    </ion-label>
    <div
    *ngIf="violation['CalculatedFine']['adjustment'] > 0"
  >
  <ion-chip *ngIf="violation['CalculatedFine']['discounted']" color="success"
        >{{('keys.data.violations.discounted' | translate : {Default:'Discounted'}) || 'Discounted'}}<ion-icon
          name="pricetag-outline"
        ></ion-icon></ion-chip
      ><ion-chip *ngIf="!violation['CalculatedFine']['discounted']" color="success"
      >{{ ('keys.data.violations.reduced' | translate : {Default:'Reduced'} )
      ||"Reduced"}}<ion-icon
        name="pricetag-outline"
      ></ion-icon></ion-chip
    >
    </div>
    <ion-label class="ion-text-right">
      <span style="font-weight: bold"
        >{{violation['CalculatedFine']['finalTotal']
        | currency}}
      </span>
    </ion-label>
  </ion-item>  
</ion-col>
  </ion-row>
  <ion-row *ngIf="violation['CalculatedFine']['adjustment'] > 0">
    <ion-col class="ion-no-padding">
      <ion-item lines="none" class="paragraph-input-fields-regular">
        <ion-label >
          {{('keys.data.violations.fine' | translate : {Default:'Amount'}) || 'Amount'}}
        </ion-label>
        <ion-label class="ion-text-right paragraph-input-fields-bold">
          {{violation['Fine']|
            currency}}
        </ion-label>
      </ion-item>  
    </ion-col>
      </ion-row>
<ion-row *ngIf="violation['CalculatedFine']['adjustment'] > 0">
<ion-col class="ion-no-padding">
<ion-item lines="none" >
  <ion-label >
    {{ ('keys.data.violations.adjustment' |
                    translate : {Default:'Adjustment'}) || 'Adjustment' }}
  </ion-label>
  <span class="ion-text-right">{{violation['CalculatedFine']['adjustment']|
      currency}}
  </span>
</ion-item>  
</ion-col>
</ion-row>
<ion-row *ngIf="violation['Plate']!=''" >
  <ion-col class="ion-no-padding">
    <ion-item lines="none" class="paragraph-input-fields-regular" >
      <ion-label >
        {{('keys.data.vehicles.plate' | translate : {Default:'Plate'}) || 'Plate'}}
      </ion-label>
      <span class="ion-text-right">
        {{violation['Plate']}}
        
      </span>
    </ion-item>  
  </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-no-padding">
        <ion-item  lines="none" class="paragraph-input-fields-regular">
          <ion-label 
            > {{ ('keys.data.common.province_or_state' | translate : {Default:'Province or State'})
            ||"Province or State"}}</ion-label
          >
          <span class="ion-text-right"
            >{{violation['ProvName']}}</span
          >
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-no-padding">
        <ion-item  lines="none" class="paragraph-input-fields-regular">
          <ion-label 
            >{{('keys.data.violations.writer' | translate : {Default:'Writer'}) || 'Writer'}}</ion-label
          >
          <span class="ion-text-right"
            >{{violation['Writer']}}</span
          >
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row  >
      <ion-col class="ion-no-padding">
        <ion-item lines="none" class="paragraph-input-fields-regular">
          <ion-label >
            {{('keys.data.violations.issued' | translate : {Default:'Issued'}) || 'Issued'}}
          </ion-label>
          <span class="ion-text-right">
            {{violation['Issued']
            |date:dataService.settings['system']['datemask']}}
            
          </span>
        </ion-item>  
      </ion-col>
        </ion-row>
        <ion-row  >
          <ion-col class="ion-no-padding">
            <ion-item lines="none" class="paragraph-input-fields-regular" >
              <ion-label >
                {{('keys.data.common.due_date' | translate : {Default:'Due'}) || 'Due'}}
              </ion-label>
              <span class="ion-text-right">
                {{violation['Due'] |
                date:dataService.settings['system']['datemask']}}
                
              </span>
            </ion-item>  
          </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="ion-no-padding">
                <ion-item lines="none" class="paragraph-input-fields-regular">
                  <ion-label 
                    >{{('keys.data.violations.ticket_type' | translate  : {Default:'Type'}) || 'Type'}}</ion-label
                  >
                  <span class="ion-text-right"
                    >{{violation['TicketTypeName']
                    }}</span
                  >
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row  >
              <ion-col class="ion-no-padding">
                <ion-item lines="none" class="paragraph-input-fields-regular">
                  <ion-label >
                    {{('keys.data.violations.location' | translate : {Default:'Location'}) || 'Location'}}
                  </ion-label>
                  <span class="ion-text-right">
                    {{violation['LocationName']
                  }}
                    
                  </span>
                </ion-item>  
              </ion-col>
                </ion-row>
                <ion-row style="border-bottom: 0.1em rgba(0, 0, 0, 0.13) solid" >
                  <ion-col class="ion-no-padding">
                    <ion-item lines="none" class="paragraph-input-fields-regular">
                      <ion-label >
                        {{('keys.data.violations.offences' | translate : {Default:'Offences'}) || 'Offences'}}
                      </ion-label>
                      <span class="ion-text-right">
                        {{violation['TicketTypeName']
                                }}
                        
                      </span>
                    </ion-item>  
                  </ion-col>
                    </ion-row>
     
</ion-grid>
</ion-col>
</ion-row>

</ion-grid>
</ion-card>
</ion-col>
</ion-row>
<ion-row>
<ion-col class="ion-no-padding">
<ion-item lines="none">
  <ion-label  style="font-weight: bold;"
    >{{ ('keys.data.common.total' |
    translate : {Default:'Total'}) || 'Total' }}
    
  </ion-label>
  <span class="ion-text-wrap ion-text-right">
    {{payment['summary']['total']| currency}}
  </span>
</ion-item>
</ion-col>
</ion-row>
<ion-row *ngIf="loaded && !step1Complete">
  <ion-col style="text-align: right" class="ion-no-padding">
    
      <ion-card class="card-shadow-3">
        <ion-item lines="none" *ngIf="payment['summary']['total']>0">
          <ion-label>{{ ('keys.data.payments.select_payment_type' |
            translate  : {Default:'Select Payment Type'}) || 'Select Payment Type' }}</ion-label>
      <ion-select 
     
        [(ngModel)]="payType"
        
        [interface]="platformSRV.interface"
        class="ion-text-right"
        [mode]="platformSRV.mode"
      >
        <ion-select-option
          *ngFor="let paymentType of payment['paymentTypes']"
          [value]="paymentType"
          >{{paymentType['PaymentTypeName']}}</ion-select-option
        >
      </ion-select>
     
    </ion-item>
    <ion-item lines="none" *ngIf="payment['summary']['total']==0">
      <ion-label >
        {{ ('keys.data.common.zero_dollar_item' |
        translate  : {Default:'Zero Dollar Item'}) || 'Zero Dollar Item' }}
      </ion-label>

    </ion-item>
   
      </ion-card>
    
      
        
      
<ion-row>
  <ion-col class="ion-no-padding">
    <ion-button
      [disabled]="submitLoading || (payType=='' && payment['summary']['total']>0)"
      color="primary"
      (click)="submitPayment()"
      expand="block"
    >
    <ion-label *ngIf="!submitLoading"
      >{{ ('keys.data.common.next' |
      translate  : {Default:'Next'}) || 'Next' }}</ion-label
    >
    <ion-item
      style="--ion-item-background: transparent"
      *ngIf="submitLoading"
    >
      <ion-label style="color: white"
        >{{ ('keys.data.payment.processing' |
        translate  : {Default:'Processing'}) || 'Processing' }} </ion-label
      ><ion-spinner style="--color: white"></ion-spinner
    ></ion-item>
         
    </ion-button>
  </ion-col>
</ion-row>
</ion-col>
</ion-row>
</ion-grid>
</ion-content>
